import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { forkJoin, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export class LanguageLoader implements TranslateLoader {
  constructor(
    private http: HttpClient,
    private basePath: string,
    private files: string[],
    private suffix = '.json'
  ) {}

  getTranslation(lang: string): Observable<any> {
    const requests = this.files.map(file =>
      this.http.get(`${this.basePath}/${lang}/${file}${this.suffix}`)
    );

    return forkJoin(requests).pipe(
      map(responseArray => Object.assign({}, ...responseArray))
    );
  }
}
